import { render, staticRenderFns } from "./SettingsSelectTag.vue?vue&type=template&id=14974d42&"
import script from "./SettingsSelectTag.vue?vue&type=script&lang=js&"
export * from "./SettingsSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports